module.exports = __webpack_public_path__ + "img/entry-image-pl.80374b05.png";